import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export interface PatientVitalParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientVitalMst {
    id?: any; 
spo2:any;
    regId: any;
    visitId:any;
    
    weight: any;
    height: any;
    bP_Sys: any;
    bP_Dia: any;
    pulse: any;
    temp: any;
    heart_Rate: any;
    resp_Rate: any;
    random_Sugar: any;
    post_Sugar: any;
    pre_Sugar: any;    
 mothersPA: any;
  mothersTVS: any;
  mothersPV: any;
  mothersUrine: any;
  mothersLiquorVolume: any;
    tenantId: any;
    branchId: any;
head_circumference?: any;

visit?: any;
    parameters?: PatientVitalParameter[];
    links?: any;
    performingDoctor?:string;
    performingNurse?:string;

    size?: string;
    waist?: string;
    bodyFat?: string;
    visceralFat?: string;
    wheelChairUsage?: string;
    urineSugar?:number | null;
}


export interface FetusVitalMaster {
  id?: any;
  regId: any;
  visitId: any;
  tenantId: any;
  branchId: any;
  fetusVitalsWeight: any;
  fetusVitalsHeartRate: any;
  fetusVitalsStation: any;
  fetusVitalsPresentations: any;
  fetusVitalsHeight: any;
  fetusVitalsMovements: any;
  fetusVitalsOcdema: any;
  fetusVitalsaddNotes: any;
  
   createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
  parameters?: PatientVitalParameter[];
  links?: any;
}

export abstract class PatientVitalData { 

    abstract list(url: string): Observable<PatientVitalMst[]>;
  abstract create(url: string, data: PatientVitalMst): Observable<any>;
  abstract createFetusVital(url: string, data: FetusVitalMaster): Observable<any>;
  abstract update(url: string, data: PatientVitalMst): Observable<any>;
  abstract listForDoctorQueue(url: string, data: any): Observable<any>;
  abstract updateFetusVital(url: string, data: FetusVitalMaster): Observable<any>;

    abstract delete(url: string): Observable<any>; 
    abstract setHeightChart(data: string): void;
    abstract heightChartData:Observable<string>;
    abstract setWeightChart(data: string): void;
    abstract weightChartData:Observable<string>;
    abstract setHcChart(data: string): void;
    abstract hcChartData:Observable<string>;
   
}
